import { faPlay, faCircleNotch } from '@fortawesome/sharp-solid-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core'

import { createElement } from '../../util/element';

import './tree_control.css';

class TreeControlNode {
   
    constructor(control, nodeList, options) {
        const { parent, node, label, children, selectFunction, expandFunction, open } = options;
        
        this.control = control;
        this.nodeList = nodeList;
        this.parent = parent;
        this.node = node;
        this.label = label;
        this.loader = children;
        this.onSelect = selectFunction;
        this.onExpand = expandFunction;
        
        this.open = open;
        this.leaf = false;
        this.loading = false;
        
        this.element = createElement("li", "tree-control-node");
        
        const content = createElement("div", "tree-control-node-content", this.element);
        
        this.iconElement = createElement("div", "tree-control-node-state", content);
        this.labelElement = createElement("div", "tree-control-node-label", content);
        
        this.iconElement.addEventListener("click", async e => await this.expandNode(e), false);
        this.labelElement.addEventListener("click", e => this.onLabelClick(e), false);

        this.updateIcon( faPlay );             
        this.updateNode();
        
        if( open ) {
            this.openExpandedChildren()
            .then(() => {
                console.log("Load children initialy");
            })
        }
    }
    
    updateNode() {
        const expanded = this.open;
        const leaf = this.children !== undefined && this.children.size === 0;
        this.element.classList.toggle("is-expanded", expanded);
        this.element.classList.toggle("is-leaf", leaf);
        
        const text = this.label(expanded, leaf);
        this.labelElement.innerHTML = text;
    }
        
    updateIcon(iconName, options) {
        this.iconElement.replaceChildren();
        this.iconElement.appendChild(icon(iconName, options).node[0]);
    }
    
    async openExpandedChildren() {
        await this.loadChildren();
        
        if( this.children !== undefined ) {
            await this.children.load();
        } 
    }
    
    async expandNode() {
        this.open = !this.open;        
        this.updateNode();

        if( this.children !== undefined ) {
            await this.children.load();
        }

        if( this.onExpand ) {
            this.onExpand(this);
        }
    }
    
    async expand() {
        if( !this.loading && !this.open ) {
            this.expandNode();
        } else if( !this.open ) {
            requestAnimationFrame(async () => {
                await this.expand();
            })
        }
        
    }   
    
    isOpen() {
        return this.open;
    }
    
    onLabelClick() {
        this.select();
        
        if( this.onSelect ) {
            this.onSelect();
        }
    }
    
    select() {
        this.control.select(this);
    }
    
    setLoading(loading) {
        this.loading = loading;
        
        if( loading ) {
            this.updateIcon( faCircleNotch, {
                classes: ['fa-spin']
            } );
        } else {
            this.updateIcon( faPlay );
        }
    }
        
    async loadChildren() {
        if( this.children === undefined ) {            
            this.setLoading(true);
            
            this.children = new TreeNodeList(this.control);
            this.element.appendChild( this.children.element );
                        
            const values = await this.loader();
                
            for( let i = 0; i < values.length; i++) {
                const value = values[i];
                this.children.add(value);
            }
                        
            this.setLoading( false );
            this.updateNode();
        }
    }    
    
    remove() {
        this.nodeList.remove( this );
        this.element.remove();
    }
    
    getValue() {
        return this.node;   
    }
    
    appendChild( childNodeOptions ) {
        if( this.children !== undefined ) {
            this.children.add( childNodeOptions );
            this.updateNode();
        }
    }
}

class TreeNodeList {
    
    constructor(control) {
        this.element = createElement("ul", "tree-control-nodes");
        this.control = control;
        this.nodes = [];
    }
    
    add(nodeOptions) {
        const node = new TreeControlNode(this.control, this, nodeOptions);                
        this.element.appendChild( node.element );
        
        this.nodes.push( node );
        
        return node;
    }    
    
    get size() {
        return this.nodes.length;
    }
    
    async load() {
        for(let i = 0; i < this.nodes.length; i++ ) {
            const node = this.nodes[i];
            await node.loadChildren();
        }
    }    
    
    find( predicate ) {
        for( let i = 0; i < this.nodes.length; i++ ) {
            const node = this.nodes[i];
            
            if( predicate(node.getValue()) ) {
                return node;
            }
        }
        
        for( let i = 0; i < this.nodes.length; i++ ) {
            const node = this.nodes[i];
            
            if( node.children ) {
                const value = node.children.find(predicate);
                if( value ) {
                    return value;
                }
            }
        }
    }
    
    remove( node ) {
        const index = this.nodes.indexOf( node );
        this.nodes.splice(index, 1);
    }
    
}

class TreeControl {
    
    constructor() {
        const container = createElement("div", "tree-control-container");

        this.container = container;
        this.rootNodes = new TreeNodeList(this);
        
        this.container.appendChild(this.rootNodes.element);        
    }
    
    getElement() {
        return this.container;
    }
    
    addRootNode(nodeOptions) {
        const node = this.rootNodes.add( nodeOptions );        
        
        node.loadChildren()
        .then(res => {
        }); 
        
        return node;       
    }
    
    find( predicate ) {
        return this.rootNodes.find( predicate );
    }
    
    select(node) {
        if( this.selection ) {
            this.selection.element.classList.remove("is-selected");
        }
        
        this.selection = node;
        node.element.classList.add("is-selected");
    } 
}

export {
    TreeControl, TreeControlNode
}